module.exports = require("string-width");


//////////////////
// WEBPACK FOOTER
// external "string-width"
// module id = 72
// module chunks = 0